import styles from './index.module.scss';


export const ROW_HEIGHT_REM = parseFloat(styles.rowHeight);
export const CHECKBOX_COLUMN_WIDTH = parseFloat(styles.checkBoxColumnWidth);
export const BODY_CELL_CLASSNAME = 'bodyCell';
